import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';

import { track } from '../../../helpers';
import { gridConfig } from '../../../config';

import Campaigns from './Campaigns';

import styles from './grid.scss';

export class Grid extends PureComponent {

    constructor() {
        super();
        this.state = {
            colCount: 3,
            initialWidthSet: false
        };
        this.gridCalculation = gridConfig.open.gridCalculation;
        this.columns = gridConfig.open.columns;
        this.minColumnCount = this.columns[this.columns.length - 1];
    }

    render() {
        const {
            id,
            campaigns,
            hiddenCampaign,
            width,
            params,
            location,
            inIFrame
        } = this.props;

        return (
            <div styleName={classNames('wrapper', { 'wrapper--no-padding': inIFrame })}>

                <Campaigns
                    {...campaigns}
                    hiddenCampaign={hiddenCampaign}
                    width={width}
                    id={id}
                    filterTag={params.filterTag}
                    location={location}
                    columnCount={this.state.colCount}
                />
            </div>
        );
    }

    setColCountOnEnterPage() {
        const colCount = this.getAvailableColumnCount(this.props.width);
        this.setState({ colCount });
    }

    getAvailableColumnCount(nextWidth) {
        const availableColumnCount = 1;
        for (let i = 0; i < this.columns.length; i++) {
            const colCount = this.columns[i];
            const width = (gridConfig[this.props.id].minWidth * 100) / this.gridCalculation[colCount].column;
            if (width <= nextWidth) {
                return colCount;
            }
        }

        return availableColumnCount;
    }

    componentWillMount() {
        // now that we have props..
        this.gridCalculation = gridConfig[this.props.id].gridCalculation;
        this.columns = gridConfig[this.props.id].columns;
        this.minColumnCount = this.columns[this.columns.length - 1];
        this.setColCountOnEnterPage();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.width !== this.props.width) {
            const colCount = this.getAvailableColumnCount(nextProps.width);
            // only track campaign when colCount changed and only for one grid
            this.setState({ colCount });
            if (this.state.initialWidthSet) {
                if (nextProps.id === 'open' && colCount !== this.state.colCount) {
                    track('campaign_overview_change', { campaignColumns: colCount });
                }
            }
            this.setState({
                initialWidthSet: true
            });
        }
    }
}

Grid.propTypes = {
    id: PropTypes.string.isRequired,
    campaigns: PropTypes.object.isRequired,
    hiddenCampaign: PropTypes.object.isRequired,
    params: PropTypes.object,
    width: PropTypes.number.isRequired,
    increment: PropTypes.func,
    location: PropTypes.object,
    inIFrame: PropTypes.bool,
};

export default CSSModules(Grid, styles, { allowMultiple: true });
